import { createStore } from 'vuex'
import { get, post } from '../utils/request'

export default createStore({
    state: {
        userInfo: null,
        categoryList: [],
        env: 'dev'
    },
    getters: {},
    mutations: {
        SET_USER_INFO(state, user) {
            state.userInfo = user
        },
        SET_CATEGORYS(state, category) {
            state.categoryList = category
        }
    },
    actions: {
        async loadCategoryList(context) {
            var res = await get('/course/categorys', {})
            console.log(res)
            if (res.code == 0) {
                context.commit('SET_CATEGORYS', res.data)
            }
        },
        async loadUserInfo(context) {
            var res = await get('/user/getUserInfo', {})
            console.log(res)
            if (res.code == 0) {
                context.commit('SET_USER_INFO', res.data)
            }
        }
    },
    modules: {}
})
